// // Append price to tooltip - ShopCircle(Danko)

// function cartPage() {
//   const editBtns = document.querySelectorAll('.bold_cart_edit_button');
//   editBtns.forEach((btn) => {
//     btn.addEventListener('click',()=>{
//       setTimeout(()=>{fixPrices()},500);
//     })
//   })
// }

// function fixPrices() {
// const prices = document.querySelectorAll('.bold_option_value_price');
// prices.forEach((price) =>{
//   const tooltip = price.previousElementSibling;
//   tooltip.innerHTML += "<br>"+"<b>"+ price.textContent +"</b>";
// })
// }

// document.addEventListener('DOMContentLoaded', function() {
//   BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {fixPrices();})
// })

// if (document.URL.includes('/cart')) {
//   setTimeout(()=>{cartPage()},2000);
// }

function executeScriptWhenClassFound() {
    const selectElements = document.querySelectorAll(".bold_option_dropdown .bold_option_element select");
selectElements.forEach(selectElement => {
    selectElement.selectedIndex = 1; // Set selected index to 1 (assuming there are at least 2 options)
    selectElement.dispatchEvent(new Event('change')); // Dispatch change event
});
}
// Function to check periodically if the target class is present in the DOM
function periodicallyCheckClassPresence() {
    const targetClass = 'bold_options';
    const targetElement = document.querySelector('.' + targetClass);
    if (targetElement) {
        console.log('Class "' + targetClass + '" is now present in the DOM.');
        // If class found, execute the script
        executeScriptWhenClassFound();
        // Stop checking once the class is found
        clearInterval(checkInterval);
    } else {
        console.log('Loading...');
    }
}
const checkInterval = setInterval(periodicallyCheckClassPresence, 1000);

// code for + sign before addon charge value

document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    console.log('Event emitted: BOLD_OPTIONS_option_products_loaded');
    var optionsDiv = document.querySelector('.bold_options_loaded');
    if (optionsDiv && optionsDiv.children.length !== 0) {
      // Select all <span> elements with the class .bold_option_value_price
const elements = document.querySelectorAll('span.bold_option_value_price');

// Loop through each element and prepend the + sign
elements.forEach(element => {
    element.textContent = `+${element.textContent}`;
});
    }
  });
});
